export enum RolesConstants {
  ADMINISTRADOR = 'ADMINISTRADOR',
  VISUALITZADOR = 'VISUALITZADOR',
  RESPONSABLE = 'RESPONSABLE'
}
